import { useApi, apiResolver } from "@/api/useApi";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { AuiChatMessage, SuggestedReplyAui } from "./SuggestedReplyAui.model";

export function useSuggestedReplyAuiApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getSuggestedReplyAuiByCommentId: (commentId: string) =>
        apiResolver<SuggestedReplyAui | undefined>(
          api.get(
            `/platform/tickets/comments/${commentId}/suggested-reply-aui`
          )
        ),
      getAuiMessageByChatMessageId: (chatMessageId: string) =>
        apiResolver<AuiChatMessage | null>(
          api.get(
            `/sessions-api/chat-messages/${chatMessageId}/aui-message`
          )
        ),
    }),
    [api]
  );
}

export function useSuggestedReplyAuiByCommentId(
  commentId: string | undefined,
  enabled: boolean
) {
  const { getSuggestedReplyAuiByCommentId } = useSuggestedReplyAuiApi();

  return useQuery({
    queryKey: ["suggested-reply-aui", commentId],
    queryFn: () =>
      commentId ? getSuggestedReplyAuiByCommentId(commentId) : undefined,
    enabled: enabled && !!commentId,
  });
}

export function useAuiMessageByChatMessageId(
  chatMessageId: string | undefined,
  enabled: boolean
) {
  const { getAuiMessageByChatMessageId } = useSuggestedReplyAuiApi();

  return useQuery({
    queryKey: ["aui-message", chatMessageId],
    queryFn: () =>
      chatMessageId ? getAuiMessageByChatMessageId(chatMessageId) : null,
    enabled: enabled && !!chatMessageId,
  });
}
